import { useState } from "react";
import "./PersonalForm.css";

function PersonalForm({
  providerData,
  setProviderData,
}) {

  const [errors, setErrors] = useState({});

 const handleChange = (field, value) => {
  setProviderData({
    ...providerData,
    owner: {
      ...providerData.owner,
      [field]: value,
    },
  });
};

  const validateField = (field, value) => {

    let message = "";

    switch (field) {

      case "name":

        if (!value.trim()) {

          message = "Full name is required.";

        }

        break;

      case "phone":

        if (!/^[6-9]\d{9}$/.test(value)) {

          message = "Enter a valid mobile number.";

        }

        break;

      case "email":

        if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
            value
          )
        ) {

          message = "Enter a valid email.";

        }

        break;

      case "gender":

        if (!value) {

          message = "Please select gender.";

        }

        break;

      default:
        break;

    }

    setErrors((prev) => ({
      ...prev,
      [field]: message,
    }));

  };

  return (

    <div className="personal-form">

      <h3>

        Personal Information

      </h3>

      <div className="form-group">

        <label>

          Full Name *

        </label>

        <input

          type="text"

          placeholder="Enter Full Name"

         value={providerData.owner.name}

          onChange={(e)=>{

            handleChange("name", e.target.value)

           validateField("name", e.target.value)

          }}

        />

        {errors.name && (
  <span className="error">{errors.name}</span>
)}

      </div>

      <div className="form-group">

        <label>

          Mobile Number *

        </label>

        <div className="phone-box">

          <span>+91</span>

          <input

            type="tel"

            maxLength={10}

            placeholder="9876543210"

            value={providerData.owner.phone}

            onChange={(e)=>{

              handleChange(
                "phone",
                e.target.value
              );

              validateField(
                "phone",
                e.target.value
              );

            }}

          />

        </div>

        {errors.phone &&

          <span className="error">

            {errors.phone}

          </span>

        }

      </div>

      <div className="form-group">

        <label>

          Email *

        </label>

        <input

          type="email"

          placeholder="example@gmail.com"

         value={providerData.owner.email}
          onChange={(e)=>{

            handleChange(
              "email",
              e.target.value
            );

            validateField(
              "email",
              e.target.value
            );

          }}

        />

        {errors.email &&

          <span className="error">

            {errors.email}

          </span>

        }

      </div>

      <div className="form-group">

        <label>

          Gender *

        </label>

        <select

         value={providerData.owner.gender || ""}

          onChange={(e)=>{

            handleChange(
              "gender",
              e.target.value
            );

            validateField(
              "gender",
              e.target.value
            );

          }}

        >

          <option value="">

            Select Gender

          </option>

          <option value="Male">

            Male

          </option>

          <option value="Female">

            Female

          </option>

          <option value="Other">

            Other

          </option>

        </select>

        {errors.gender &&

          <span className="error">

            {errors.gender}

          </span>

        }

      </div>

    </div>

  );

}

export default PersonalForm;